export enum RequestType {
	Complaint = 1,
	Notice = 2,
	ProfessionalMonitoring = 3,
}
